module.exports = __webpack_public_path__ + "static/media/craft-05.5f9046d4.svg";